"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.distributePositiveReferenceVoucherPreInterest = exports.getExpirationSettings = exports.changes = exports.calculate = void 0;
const moment_1 = __importDefault(require("moment"));
const __1 = __importDefault(require(".."));
const __2 = require("../../..");
const vouchers_1 = require("../../vouchers");
const utils_1 = require("../utils");
const common_1 = require("./common");
const setup_1 = require("../../vouchers/setup");
const documents_1 = require("../../../documents");
const distributor_1 = require("../distributor");
const interestOrderHashMap = {
    cost: 1,
    courtcost: 2,
    interest: 3,
    principal: 4,
};
const calculate = (caseVouchers, documents, expirationSettings, untilISOString, appendHist, postProcessing, c) => {
    var _a, _b, _c;
    const until = (0, common_1.parseDate)(untilISOString);
    const _caseVouchers = __1.default.vouchers.postProcessing(caseVouchers, {
        includeIrrecoverableVouchers: ((_a = postProcessing === null || postProcessing === void 0 ? void 0 : postProcessing.filter) === null || _a === void 0 ? void 0 : _a.includeIrrecoverableVouchers) || false,
        includeDeletedVouchers: ((_b = postProcessing === null || postProcessing === void 0 ? void 0 : postProcessing.filter) === null || _b === void 0 ? void 0 : _b.includeDeletedVouchers) || false,
        includeExpiredVouchers: ((_c = postProcessing === null || postProcessing === void 0 ? void 0 : postProcessing.filter) === null || _c === void 0 ? void 0 : _c.includeExpiredVouchers) || false,
    });
    let filters = [
        utils_1.sortBySameCategoryDateDescFirst,
        (a, b) => (interestOrderHashMap[a.category] || 0) -
            (interestOrderHashMap[b.category] || 0),
    ];
    const dateFilter = (a, b) => new Date(a.date).getTime() - new Date(b.date).getTime();
    const allBreakpoints = (0, common_1.getOrderedBreakpoints)(_caseVouchers, until);
    const validSpans = calculateValidSpans(_caseVouchers, documents, expirationSettings, until);
    filters = filters.concat([dateFilter, (a, b) => a.id - b.id]);
    return __1.default.distributor.distribute((0, utils_1.clone)(_caseVouchers).map((v) => {
        var _a;
        if (v.setting && setup_1.CaseVoucherInterestSettings.includes(v.setting)) {
            v.amount = 0;
            if (((_a = v.details) === null || _a === void 0 ? void 0 : _a.legacyInterestExpiration) &&
                v.interestStartDate &&
                !v.interestEndDate) {
                const interestEndDate = (0, moment_1.default)(until).subtract(3, 'years');
                if ((0, moment_1.default)(v.interestStartDate).isBefore(interestEndDate)) {
                    v.interestStartDate = interestEndDate.format();
                }
            }
        }
        return v;
    }), (0, utils_1.sortByWithExtraDiscriminator)(...filters), exports.distributePositiveReferenceVoucherPreInterest, (_currState, _prevState, voucher, nextVoucher) => {
        return (0, common_1.withBreakpoints)(allBreakpoints, until, _currState, _prevState, voucher, nextVoucher, (currState, prevState, breakpointFrom, breakpointTo, breakpointToType) => {
            var _a;
            for (let i = 0; i < currState.length; i++) {
                const interestCaseVoucher = currState[i];
                if (!(interestCaseVoucher.setting &&
                    setup_1.CaseVoucherInterestSettings.includes(interestCaseVoucher.setting))) {
                    continue;
                }
                if (interestCaseVoucher.deletedAt) {
                    continue;
                }
                if (!interestCaseVoucher.interestStartDate) {
                    throw new Error('No interest start date on interest');
                }
                const interestStartDate = (0, common_1.parseDate)(interestCaseVoucher.interestStartDate);
                const interestEndDate = interestCaseVoucher.interestEndDate
                    ? (0, common_1.parseDate)(interestCaseVoucher.interestEndDate)
                    : null;
                if (!(interestStartDate < breakpointTo &&
                    (!interestEndDate ||
                        (interestEndDate && interestEndDate > breakpointFrom)) &&
                    until > interestStartDate)) {
                    continue;
                }
                let from;
                if (breakpointFrom < interestStartDate) {
                    from = interestStartDate;
                }
                else {
                    from = breakpointFrom;
                }
                let to;
                const voucherTo = interestEndDate && interestEndDate < breakpointTo
                    ? interestEndDate
                    : breakpointTo;
                if (until < voucherTo) {
                    to = until;
                }
                else {
                    to = voucherTo;
                }
                if (from > to) {
                    throw new Error('Interest period is invalid');
                }
                const refDebt = prevState.find((rD) => rD.caseVoucherId === interestCaseVoucher.referenceCaseVoucherId);
                const refDebtFromVouchers = !refDebt &&
                    _caseVouchers.find((rD) => rD.caseVoucherId ===
                        interestCaseVoucher.referenceCaseVoucherId);
                const refAmount = ((refDebt
                    ? refDebt.amount
                    : refDebtFromVouchers
                        ? refDebtFromVouchers.amount
                        : 0) || 0) - (refDebt ? refDebt.distributionAmount : 0);
                let capitalizedInterestAmount = 0;
                if (interestCaseVoucher.setting ===
                    vouchers_1.VoucherTypeSetting.CompoundInterest) {
                    capitalizedInterestAmount =
                        interestCaseVoucher.amountAtCapitalization || 0;
                    const uncapitalizedInterestAmount = interestCaseVoucher.amount - capitalizedInterestAmount;
                    const amountToSubractFromCapitalizedAmount = uncapitalizedInterestAmount -
                        interestCaseVoucher.distributionAmount;
                    if (amountToSubractFromCapitalizedAmount > 0) {
                        capitalizedInterestAmount +=
                            amountToSubractFromCapitalizedAmount;
                    }
                }
                let interests;
                if (interestCaseVoucher.setting ===
                    vouchers_1.VoucherTypeSetting.InterestFromTable) {
                    interests = (0, common_1.getInterestRatesGen)(interestCaseVoucher.settingDetails.interestRates)(from, to);
                }
                else if ([
                    vouchers_1.VoucherTypeSetting.YearlyInterest,
                    vouchers_1.VoucherTypeSetting.CompoundInterest,
                ].includes(interestCaseVoucher.setting) &&
                    typeof interestCaseVoucher.interest === 'number') {
                    interests = [{ rate: interestCaseVoucher.interest }];
                }
                else {
                    throw new Error(`Interest type not handled (setting: ${interestCaseVoucher.setting}, voucher id: ${interestCaseVoucher.caseVoucherId})`);
                }
                for (let g = 0; g < interests.length; g++) {
                    const interestPeriod = interests[g];
                    const nextInterestPeriod = interests[g + 1];
                    const interestPeriodFrom = interestPeriod.time && interestPeriod.time >= from
                        ? interestPeriod.time
                        : from;
                    const interestPeriodTo = nextInterestPeriod &&
                        nextInterestPeriod.time &&
                        nextInterestPeriod.time <= to
                        ? nextInterestPeriod.time
                        : to;
                    const spans = (c === null || c === void 0 ? void 0 : c.preventInterestExpiration) ||
                        ((_a = interestCaseVoucher.details) === null || _a === void 0 ? void 0 : _a.preventInterestExpiration) ||
                        (interestCaseVoucher.interestStartDate != null &&
                            interestCaseVoucher.interestEndDate != null)
                        ? [[interestPeriodFrom, interestPeriodTo]]
                        : calculateOverlap(validSpans, [
                            interestPeriodFrom,
                            interestPeriodTo,
                        ]);
                    for (const [interestPeriodFrom, interestPeriodTo] of spans) {
                        const interestDays = (interestPeriodTo - interestPeriodFrom) / common_1.ONE_DAY_IN_MS;
                        if (interestDays % 1 != 0) {
                            throw new Error('Number of interest days cannot be with decimal places');
                        }
                        const interestPerDay = Math.round(((refAmount + capitalizedInterestAmount) *
                            interestPeriod.rate) /
                            (0, vouchers_1.daysAYear)(interestCaseVoucher));
                        const amountToBeAdded = interestPerDay * interestDays;
                        currState[i] = (0, common_1.addAmountToVoucher)(interestCaseVoucher, amountToBeAdded, appendHist
                            ? {
                                from: interestPeriodFrom,
                                to: interestPeriodTo,
                                interest: interestPeriod.rate,
                                referenceVoucherBalance: refAmount,
                                capitalizedInterestBalance: capitalizedInterestAmount,
                            }
                            : undefined);
                        if (interestCaseVoucher.setting ===
                            vouchers_1.VoucherTypeSetting.CompoundInterest &&
                            common_1.COMPOUNDING_PERIOD_TO_BREAKPOINT_TYPE[interestCaseVoucher.settingDetails.compoundingPeriod] === breakpointToType) {
                            currState[i] = Object.assign(Object.assign({}, interestCaseVoucher), { amountAtCapitalization: interestCaseVoucher.amount });
                        }
                    }
                }
            }
            return currState;
        });
    });
};
exports.calculate = calculate;
const changes = (vouchers) => {
    const _changes = [];
    for (let i = 0; i < vouchers.length; i++) {
        vouchers[i].amountUpdated &&
            _changes.push({
                amount: vouchers[i].amount,
                caseVoucherId: vouchers[i].caseVoucherId,
            });
    }
    return _changes;
};
exports.changes = changes;
const calculateValidSpans = (caseVouchers, documents, settings, until) => {
    var _a;
    const expirationCheckpoints = documents
        .filter((d) => (0, documents_1.doesDocumentExtendExpiration)(d))
        .map((d) => { var _a; return new Date((_a = d.signedAt) !== null && _a !== void 0 ? _a : d.date).getTime(); })
        .concat(caseVouchers
        .filter((cv) => cv.voucherTypeId === vouchers_1.VoucherTypeIds.DEPOSIT)
        .map((cv) => new Date(cv.date).getTime()))
        .concat([until]);
    expirationCheckpoints.sort((a, b) => a - b);
    let lockedPeriods = [];
    for (const checkpoint of expirationCheckpoints) {
        const start = (0, moment_1.default)(checkpoint)
            .subtract((_a = settings.trailingYears) !== null && _a !== void 0 ? _a : 3, 'years')
            .utc()
            .startOf('day')
            .valueOf();
        const end = (0, moment_1.default)(checkpoint).utc().startOf('day').valueOf();
        if (lockedPeriods.length === 0) {
            lockedPeriods.push([start, end]);
            continue;
        }
        const latest = lockedPeriods[lockedPeriods.length - 1];
        if (start <= latest[1]) {
            latest[1] = end;
        }
        else {
            lockedPeriods.push([start, end]);
        }
    }
    return lockedPeriods;
};
const calculateOverlap = (validSpans, attempt) => {
    let neu = [];
    for (const span of validSpans) {
        if (attempt[0] < span[0] && attempt[1] > span[0]) {
            if (attempt[1] > span[1]) {
                neu.push([span[0], span[1]]);
            }
            else {
                neu.push([span[0], attempt[1]]);
            }
        }
        if (attempt[0] >= span[0] && attempt[0] < span[1]) {
            if (attempt[1] > span[1]) {
                neu.push([attempt[0], span[1]]);
            }
            else {
                neu.push([attempt[0], attempt[1]]);
            }
        }
    }
    return neu;
};
const defaultExpirationSettings = {
    trailingYears: 3,
};
const getBaseExpirationSettings = (country) => {
    if (country === __2.CountryCode.DK) {
        return {
            trailingYears: 3,
        };
    }
    else if (country === __2.CountryCode.GL) {
        return {
            trailingYears: 5,
        };
    }
    return defaultExpirationSettings;
};
const getExpirationSettings = (tenant, creditor) => {
    var _a;
    let settings = getBaseExpirationSettings(tenant.countryCode);
    if (((_a = creditor.settings.customExpiration) === null || _a === void 0 ? void 0 : _a.interest) != null) {
        settings.trailingYears = creditor.settings.customExpiration.interest;
    }
    return settings;
};
exports.getExpirationSettings = getExpirationSettings;
const distributePositiveReferenceVoucherPreInterest = (caseVouchers) => {
    const positiveVouchers = caseVouchers.filter((v) => v.amount > 0);
    const negativeVouchers = caseVouchers.filter((v) => v.amount <= 0);
    for (const positiveVoucher of positiveVouchers) {
        if (!positiveVoucher.referenceCaseVoucherId)
            continue;
        const matchingNegativeVoucher = negativeVouchers.find((v) => v.caseVoucherId === positiveVoucher.referenceCaseVoucherId);
        if (!matchingNegativeVoucher) {
            console.error(`[Pre-interest distribution]: Could not find matching negative voucher for referenceId ${positiveVoucher.referenceCaseVoucherId} on voucher ${positiveVoucher.caseVoucherId}`);
            continue;
        }
        const from = positiveVoucher.distributionAmount - positiveVoucher.amount;
        if (from === 0)
            continue;
        const to = matchingNegativeVoucher.distributionAmount -
            matchingNegativeVoucher.amount;
        const distributionAmount = to < -from ? -to : from;
        (0, distributor_1.appendToDistributionOnVoucher)(positiveVoucher, -distributionAmount, matchingNegativeVoucher.caseVoucherId, matchingNegativeVoucher.date);
        (0, distributor_1.appendToDistributionOnVoucher)(matchingNegativeVoucher, distributionAmount, positiveVoucher.caseVoucherId, positiveVoucher.date);
    }
    return caseVouchers;
};
exports.distributePositiveReferenceVoucherPreInterest = distributePositiveReferenceVoucherPreInterest;
//# sourceMappingURL=index.js.map